/* ==========================================================================
   Modale selezione corso - Sistema ADC

   Wizard che accompagna il visitatore in un massimo di quattro domande
   (per cosa studi / quale versione / quanto tempo hai / quale facoltà) e
   mostra la scheda del corso consigliato.

   I dati non stanno qui dentro: arrivano dal foglio Google e vengono
   inseriti dalla build nella variabile MODALE_SELEZIONE_CORSO_DATI, subito
   sopra questo codice. Qui c'è solo il comportamento.
   ========================================================================== */

(function () {
  "use strict";

  var DATI = window.MODALE_SELEZIONE_CORSO_DATI;
  if (!DATI) return;

  var CONFIG = DATI.config;         // preferenze (tab 0Preferenze)
  var TESTI = DATI.questions;       // domande, opzioni, etichette (tab 0Domande)
  var CATALOGO = DATI.catalog;      // le schede risultato (tab 0Copy & Labels)
  var CORSI = DATI.courses;         // i corsi di studio con la loro macroarea

  /* ---------------------------------------------------------------- varianti

     Dallo stesso sorgente escono quattro build. Cambia solo da quale
     domanda si parte e se livello o versione sono già decisi in partenza. */

  var VARIANTI = {
    "generale": { passoIniziale: "level" },
    "solo-universita": { livelloFisso: "university", passoIniziale: "tier" },
    "solo-concorsi": { livelloFisso: "civil-service-exam", passoIniziale: "tier" },
    "upgrade": { tierFisso: "pro", passoIniziale: "level" }
  };

  // il pannello passa il percorso già descritto; la build a riga di comando
  // passa invece il nome di una delle quattro varianti
  var VARIANTE = DATI.percorso || VARIANTI[DATI.variante] || VARIANTI.generale;
  var PASSO_INIZIALE = VARIANTE.passoIniziale || "level";
  var LIVELLO_FISSO = VARIANTE.livelloFisso || null;
  var TIER_FISSO = VARIANTE.tierFisso || null;

  /* ------------------------------------------------------- costanti d'aspetto

     Non arrivano dal foglio: sono scelte fisse della build originale. */

  var LAYOUT_RISULTATO = "image-left-text-right";  // immagine a sinistra, testo a destra
  var PRESET_ANIMAZIONE = "extreme";               // ampiezza dell'animazione d'ingresso

  var RITARDO_PRIMA_SCELTA = 125;      // ms prima che compaia la prima opzione
  var RITARDO_TRA_SCELTE = 110;        // ms fra un'opzione e la successiva
  var RITARDO_TESTO_RISULTATO = 95;    // ms prima del testo della scheda
  var RITARDO_IMMAGINE_RISULTATO = 150;// ms prima dell'immagine della scheda
  var ATTESA_MASSIMA_IMMAGINI = 1200;  // ms: oltre questo la modale si mostra comunque

  /* ------------------------------------------------------------------ utilità */

  var formattaIntero = new Intl.NumberFormat("it-IT", {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0
  });

  var formattaCentesimi = new Intl.NumberFormat("it-IT", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2
  });

  /* I prezzi tondi si scrivono senza decimali (690€); quelli con i centesimi
     li mostrano tutti e due, come su uno scontrino (586,50€ e non 586,5€). */
  function prezzo(valore) {
    var tondo = Math.abs(valore % 1) < 0.005;
    return (tondo ? formattaIntero : formattaCentesimi).format(valore) + "€";
  }

  function elemento(tag, classi, testo) {
    var el = document.createElement(tag);
    if (classi) el.className = classi;
    if (testo !== undefined && testo !== null) el.textContent = testo;
    return el;
  }

  /** Aggiunge l'animazione d'ingresso, eventualmente ritardata. */
  function animaIngresso(el, ritardoMs) {
    el.classList.add("course-selection-animate-in");
    if (ritardoMs > 0) {
      el.style.setProperty("--course-selection-enter-delay", ritardoMs + "ms");
    } else {
      el.style.removeProperty("--course-selection-enter-delay");
    }
  }

  function ritardoOpzione(indice) {
    return RITARDO_PRIMA_SCELTA + indice * RITARDO_TRA_SCELTE;
  }

  /** "Àbc, dèf" -> "abc, def": minuscolo e senza accenti, per la ricerca. */
  function normalizza(testo) {
    return testo.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim();
  }

  function parole(testoNormalizzato) {
    return testoNormalizzato.split(/[^a-z0-9]+/).filter(Boolean);
  }

  /* -------------------------------------------------------- catalogo e testi */

  /** Le righe del catalogo compatibili con le scelte fatte finora. */
  function righeCompatibili(scelte) {
    return CATALOGO.filter(function (riga) {
      if (scelte.level && riga.level !== scelte.level) return false;
      if (scelte.tier && riga.tier !== scelte.tier) return false;
      if (scelte.commitment && riga.commitment && riga.commitment !== scelte.commitment) return false;
      if (scelte.macro && riga.macro && riga.macro !== scelte.macro) return false;
      return true;
    });
  }

  /** La scheda da mostrare: la prima riga compatibile con tutte le scelte. */
  function corsoScelto(scelte) {
    var righe = CATALOGO.filter(function (riga) {
      return riga.tier === scelte.tier &&
        riga.level === scelte.level &&
        (riga.commitment || "") === (scelte.commitment || "") &&
        (riga.macro || "") === (scelte.macro || "");
    });
    return righe[0] || null;
  }

  /** Le versioni (BASE/PRO/MASTER) disponibili per il livello scelto. */
  function tierDisponibili(scelte) {
    var ordine = ["base", "pro", "master"];
    var presenti = [];
    righeCompatibili({ level: scelte.level }).forEach(function (riga) {
      if (presenti.indexOf(riga.tier) < 0) presenti.push(riga.tier);
    });
    return ordine.filter(function (t) {
      return presenti.indexOf(t) >= 0 && (!TIER_FISSO || t === TIER_FISSO);
    });
  }

  /** Prezzo da mostrare sotto una versione, nella domanda 2. */
  function prezzoTier(tier, scelte) {
    var righe = righeCompatibili({ level: scelte.level, tier: tier });
    return righe.length ? righe[0] : null;
  }

  function etichettaBreve(valore) {
    return (TESTI.shortLabels && TESTI.shortLabels[valore]) || "";
  }

  function domanda(passo) {
    return TESTI.guidingQuestions[passo] || { label: "" };
  }

  function opzione(valore) {
    return TESTI.selectOptions[valore] || { label: valore };
  }

  /* ------------------------------------------------------------------- stato */

  var stato = {
    passo: PASSO_INIZIALE,
    scelte: {
      level: LIVELLO_FISSO || undefined,
      tier: TIER_FISSO || undefined,
      commitment: undefined,
      facultyId: undefined,
      facultyLabel: undefined,
      macro: undefined
    }
  };

  /** Per i concorsi la domanda sul tempo pieno si può disattivare dal foglio. */
  function saltaDomandaTempo(scelte) {
    return scelte.level === "civil-service-exam" && !CONFIG.show_civil_exam_commitment;
  }

  /**
   * Decide dove ci si trova dopo una scelta: la domanda successiva oppure
   * il risultato. Le domande che hanno una sola risposta possibile vengono
   * risolte da sole, senza chiederle.
   */
  function calcolaPassoSuccessivo() {
    var s = stato.scelte;
    if (LIVELLO_FISSO) s.level = LIVELLO_FISSO;
    if (TIER_FISSO) s.tier = TIER_FISSO;

    if (!s.level) {
      azzeraDa("level");
      stato.passo = PASSO_INIZIALE;
      return;
    }
    if (s.level === "school") {          // per la scuola esiste solo la versione BASE
      s.tier = "base";
      azzeraDa("commitment");
      stato.passo = "result";
      return;
    }
    if (!s.tier) {
      azzeraDa("commitment");
      stato.passo = "tier";
      return;
    }
    if (s.tier === "base") {             // BASE non chiede né tempo né facoltà
      azzeraDa("commitment");
      stato.passo = "result";
      return;
    }
    if (saltaDomandaTempo(s)) {
      s.commitment = "full";
      azzeraDa("faculty");
      stato.passo = "result";
      return;
    }
    if (s.level === "civil-service-exam" && s.commitment) {
      azzeraDa("faculty");
      stato.passo = "result";
    } else if (s.level === "university" && s.commitment && s.macro) {
      stato.passo = "result";
    } else if (!s.commitment) {
      azzeraDa("faculty");
      stato.passo = "commitment";
    } else {
      azzeraDa("faculty");
      stato.passo = "faculty";
    }
  }

  /** Cancella le scelte da un certo punto in poi (si torna indietro). */
  function azzeraDa(passo) {
    var s = stato.scelte;
    if (passo === "level") { s.level = LIVELLO_FISSO || undefined; s.tier = TIER_FISSO || undefined; }
    if (passo === "level" || passo === "tier") { s.tier = TIER_FISSO || undefined; }
    if (passo === "level" || passo === "tier" || passo === "commitment") { s.commitment = undefined; }
    s.facultyId = undefined;
    s.facultyLabel = undefined;
    s.macro = undefined;
  }

  /** Qual è la domanda precedente rispetto a dove ci troviamo. */
  function passoPrecedente(passo) {
    var s = stato.scelte;
    if (passo === "result") {
      if (s.level === "school") return "level";
      if (s.tier === "base") return "tier";
      if (s.level === "civil-service-exam") {
        return saltaDomandaTempo(s) ? (TIER_FISSO ? "level" : "tier") : "commitment";
      }
      return s.level === "university" ? "faculty" : "commitment";
    }
    if (passo === "faculty") return "commitment";
    if (passo === "commitment") return TIER_FISSO ? "level" : "tier";
    if (passo === "tier") return PASSO_INIZIALE;
    return "level";
  }

  /** Torna a una domanda già data, dimenticando le risposte successive. */
  function tornaA(passo) {
    azzeraDa(passo === "faculty" ? "faculty" : passo);
    if (LIVELLO_FISSO) stato.scelte.level = LIVELLO_FISSO;
    if (TIER_FISSO) stato.scelte.tier = TIER_FISSO;
    stato.passo = passo;
  }

  /**
   * Le barre di avanzamento da mostrare in alto: dipendono da dove siamo.
   * Finché non si sceglie il livello ce n'è una sola; poi compaiono quelle
   * delle domande che il percorso scelto prevede davvero.
   */
  function passiVisibili() {
    var s = stato.scelte;
    // se la versione è già decisa (le modali di upgrade) la sua domanda non
    // viene fatta: non deve comparire nemmeno il suo tratto nella barra
    if (TIER_FISSO) {
      if (!s.level) return ["level"];
      return s.level === "civil-service-exam" ? ["level"] : ["level", "commitment", "faculty"];
    }
    if (!s.level) return ["level"];
    if (s.level === "school") return ["level"];
    if (!s.tier || s.tier === "base" || s.level === "civil-service-exam") {
      return PASSO_INIZIALE === "tier" ? ["tier"] : ["level", "tier"];
    }
    return PASSO_INIZIALE === "tier"
      ? ["tier", "commitment", "faculty"]
      : ["level", "tier", "commitment", "faculty"];
  }

  /* ------------------------------------------------------ elementi della pagina */

  var dom = {
    modale: document.getElementById("course-selection-modal"),
    nav: document.getElementById("course-selection-nav"),
    indietro: document.getElementById("course-selection-nav-back"),
    breadcrumb: document.getElementById("course-selection-nav-breadcrumb"),
    pannelli: document.getElementById("course-selection-panels"),
    areaDomande: document.getElementById("course-selection-selection-area"),
    areaRisultato: document.getElementById("course-selection-results-area"),
    barre: [1, 2, 3, 4].map(function (n) {
      return {
        contenitore: document.getElementById("course-selection-step-" + n + "-container"),
        etichetta: document.getElementById("course-selection-step-" + n + "-label")
      };
    })
  };

  if (!dom.modale) return;

  /* ------------------------------------------------------------- immagini

     Le immagini vengono caricate in memoria prima di essere mostrate, così
     non compaiono a pezzi: finché non sono pronte il contenitore resta
     "is-loading". */

  var immaginiCaricate = {};

  function caricaImmagine(url) {
    if (!url) return Promise.resolve(false);
    if (immaginiCaricate[url]) return immaginiCaricate[url];
    immaginiCaricate[url] = new Promise(function (risolvi) {
      var img = new Image();
      img.onload = function () { risolvi(true); };
      img.onerror = function () { risolvi(false); };
      img.decoding = "async";
      img.src = url;
    });
    return immaginiCaricate[url];
  }

  function attendiImmagini(urls, millisecondiMassimi) {
    var tutte = Promise.all(urls.map(caricaImmagine));
    var scadenza = new Promise(function (risolvi) {
      window.setTimeout(risolvi, millisecondiMassimi);
    });
    return Promise.race([tutte, scadenza]);
  }

  /* -------------------------------------------------------- barra di avanzamento */

  function aggiornaNav() {
    var s = stato.scelte;
    var visibili = passiVisibili();

    var passi = [
      { passo: "level", completato: !!(s.level && s.level !== "school"), etichetta: s.level && s.level !== "school" ? etichettaBreve(s.level) : "", ripiego: domanda("level").label },
      { passo: "tier", completato: !!s.tier, etichetta: s.tier ? etichettaBreve(s.tier) : "", ripiego: domanda("tier").label },
      { passo: "commitment", completato: !!s.commitment, etichetta: s.commitment ? etichettaBreve(s.commitment) : "", ripiego: domanda("commitment").label },
      { passo: "faculty", completato: !!s.macro, etichetta: s.facultyLabel || "", ripiego: domanda("macro").label }
    ];

    dom.indietro.disabled = passoPrecedente(stato.passo) === stato.passo;
    dom.indietro.classList.toggle("disabled", dom.indietro.disabled);

    passi.forEach(function (p, i) {
      var barra = dom.barre[i];
      var posizione = visibili.indexOf(p.passo);
      var corrente = stato.passo === p.passo;
      var descrizione = p.etichetta || p.ripiego;

      barra.contenitore.hidden = posizione < 0;
      barra.etichetta.innerText = p.etichetta;
      barra.contenitore.classList.toggle("active", p.completato);
      barra.contenitore.classList.toggle("inactive", !p.completato);
      barra.contenitore.disabled = !(p.completato && !corrente);
      barra.contenitore.setAttribute(
        "aria-label",
        posizione >= 0 ? "Step " + (posizione + 1) + ", " + descrizione : descrizione
      );
      if (corrente) barra.contenitore.setAttribute("aria-current", "step");
      else barra.contenitore.removeAttribute("aria-current");

      p.visibile = posizione >= 0;
      p.descrizione = descrizione;
    });

    aggiornaBreadcrumb(passi.filter(function (p) { return p.visibile && p.completato; }));
  }

  /** Su mobile, al posto delle barre, il percorso fatto: Università » Pro » ... */
  function aggiornaBreadcrumb(passiCompletati) {
    var frammento = document.createDocumentFragment();

    passiCompletati.forEach(function (p, i) {
      var corrente = stato.passo === p.passo;
      var cliccabile = p.completato && !corrente;
      var voce = document.createElement(cliccabile ? "button" : "span");

      voce.className = "course-selection-nav-breadcrumb-item " + (corrente ? "current" : "completed");
      voce.textContent = p.etichetta;
      if (p.etichetta) voce.setAttribute("title", p.etichetta);
      voce.dataset.breadcrumbIndex = String(i + 1);
      if (cliccabile) {
        voce.type = "button";
        voce.dataset.breadcrumbStep = p.passo;
        voce.setAttribute("aria-label", "Step " + (i + 1) + ", " + p.descrizione);
      }
      if (corrente) voce.setAttribute("aria-current", "step");

      frammento.appendChild(voce);
      if (i < passiCompletati.length - 1) {
        var separatore = elemento("span", "course-selection-nav-breadcrumb-separator", "»");
        separatore.setAttribute("aria-hidden", "true");
        frammento.appendChild(separatore);
      }
    });

    dom.breadcrumb.replaceChildren(frammento);
  }

  /* --------------------------------------------------------- domande a scelta */

  /** Le opzioni della domanda in corso. */
  function opzioniDelPasso(passo) {
    var s = stato.scelte;
    if (passo === "level") {
      return ["school", "university", "civil-service-exam"].filter(function (livello) {
        return CATALOGO.some(function (r) { return r.level === livello; });
      });
    }
    if (passo === "tier") return tierDisponibili(s);
    if (passo === "commitment") return ["full", "part"];
    return [];
  }

  function creaDomanda(passo) {
    var sezione = document.createElement("section");
    var idTitolo = "course-selection-question-heading-" + passo;

    var contenitore = elemento("div", "course-selection-question-container course-selection-additional-ui course-selection-animate-in-surface");
    animaIngresso(contenitore, 0);
    if (CONFIG.show_counter && domanda(passo).counter) {
      contenitore.appendChild(elemento("p", "course-selection-question-counter", domanda(passo).counter));
    }
    var titolo = elemento("h2", "course-selection-question-heading", domanda(passo).label);
    titolo.id = idTitolo;
    contenitore.appendChild(titolo);
    sezione.appendChild(contenitore);

    // solo nella domanda sulle versioni: la riga che rimanda al video
    if (passo === "tier" && TESTI.guide && TESTI.guide.tier) {
      sezione.appendChild(elemento("p", "course-selection-tier-guide", TESTI.guide.tier));
    }

    var gruppo = elemento("div", "course-selection-choice-group");
    gruppo.setAttribute("role", "group");
    gruppo.setAttribute("aria-labelledby", idTitolo);
    var riga = elemento("div", "select-question-choices-row");

    opzioniDelPasso(passo).forEach(function (valore, i) {
      riga.appendChild(creaScelta(passo, valore, i));
    });

    gruppo.appendChild(riga);
    sezione.appendChild(gruppo);
    return sezione;
  }

  function creaScelta(passo, valore, indice) {
    var testi = opzione(valore);
    var bottone = elemento("button", "select-question-choice");
    bottone.type = "button";
    bottone.dataset.choiceStep = passo;
    bottone.dataset.choiceValue = valore;
    bottone.dataset.selected = "false";
    bottone.setAttribute("aria-pressed", "false");
    animaIngresso(bottone, ritardoOpzione(indice));

    var media = elemento("div", "select-question-choice-media is-loading");
    var img = elemento("img", "select-question-choice-image");
    img.alt = "";
    img.decoding = "async";
    img.loading = "eager";
    if (testi.picture) {
      img.dataset.imageUrl = testi.picture;
      caricaImmagine(testi.picture).then(function (ok) {
        if (!ok) return;
        img.src = testi.picture;
        media.classList.remove("is-loading");
        media.classList.add("is-ready");
      });
    }
    media.appendChild(img);
    bottone.appendChild(media);

    bottone.appendChild(elemento("span", "select-question-choice-label", testi.label));

    if (passo === "tier") {
      var descrizione = TESTI.tierDescriptions && TESTI.tierDescriptions[valore];
      if (descrizione) {
        bottone.appendChild(elemento("span", "select-question-choice-description", descrizione));
      }
      var riga = prezzoTier(valore, stato.scelte);
      if (CONFIG.show_button_price && riga && (riga.priceFull != null || riga.priceDiscounted != null)) {
        bottone.classList.add("has-tier-price-slot");
        bottone.appendChild(creaPrezzo("course-selection-tier-price", "span", riga));
      }
    }

    bottone.addEventListener("click", function () {
      // cambiando risposta si dimenticano quelle successive: senza questo,
      // dopo "Scuole superiori" (che decide da sé la versione BASE) un clic
      // su "Università" salterebbe la domanda sulla versione
      azzeraDa(passo);
      stato.scelte[passo === "faculty" ? "macro" : passo] = valore;
      calcolaPassoSuccessivo();
      disegna();
    });

    return bottone;
  }

  /** Il blocco prezzo: pieno barrato (se c'è uno sconto) e prezzo in evidenza. */
  function creaPrezzo(classe, tag, riga) {
    var contenitore = elemento(tag, classe);
    contenitore.setAttribute("aria-hidden", "false");
    if (riga.priceDiscounted != null && riga.priceFull != null) {
      contenitore.appendChild(elemento("del", "course-selection-price-full", prezzo(riga.priceFull)));
      contenitore.appendChild(elemento("span", "course-selection-price-main", prezzo(riga.priceDiscounted)));
    } else {
      var valore = riga.priceDiscounted != null ? riga.priceDiscounted : riga.priceFull;
      contenitore.appendChild(elemento("span", "course-selection-price-main", prezzo(valore)));
    }
    return contenitore;
  }

  /* ------------------------------------------------------- domanda sulla facoltà

     Un campo di testo con i suggerimenti: si digita e compaiono i corsi di
     studio che contengono quel testo. Ogni corso porta con sé la macroarea
     (MED, ING, GIU, ...) che serve per trovare la scheda giusta. */

  var CORSI_INDICIZZATI = indicizzaCorsi(CORSI);

  function indicizzaCorsi(elenco) {
    var usati = {};
    return elenco.map(function (corso) {
      var etichettaNormalizzata = normalizza(corso.name);
      var id = corso.id || identificatore(corso.name);
      // due corsi possono chiamarsi uguale: il secondo prende -1, il terzo -2
      if (usati[id] === undefined) usati[id] = 0;
      else id = id + "-" + (++usati[id]);
      return {
        id: id,
        label: corso.name,
        macro: corso.macro,
        normalizzato: etichettaNormalizzata,
        parole: parole(etichettaNormalizzata)
      };
    });
  }

  /** "Medicina e chirurgia" -> "medicina-e-chirurgia" (serve solo per gli id). */
  function identificatore(testo) {
    return normalizza(testo)
      .replace(/[^a-z0-9\s-]/g, "")   // via punteggiatura e apostrofi, i trattini restano
      .replace(/\s+/g, "-")
      .replace(/-{2,}/g, "-");
  }

  /**
   * Quanto bene un corso risponde a quello che è stato digitato:
   * 0 = uguale, 1 = comincia così, 2 = una parola comincia così,
   * 3 = lo contiene, -1 = non c'entra. I risultati escono in quest'ordine.
   */
  function punteggio(corso, cercato) {
    if (corso.normalizzato === cercato) return 0;
    if (corso.normalizzato.indexOf(cercato) === 0) return 1;
    for (var i = 0; i < corso.parole.length; i++) {
      if (corso.parole[i].indexOf(cercato) === 0) return 2;
    }
    return corso.normalizzato.indexOf(cercato) >= 0 ? 3 : -1;
  }

  function cercaCorsi(testo) {
    var cercato = normalizza(testo);
    if (!cercato) return CORSI_INDICIZZATI.slice();
    var gruppi = [[], [], [], []];
    CORSI_INDICIZZATI.forEach(function (corso) {
      var p = punteggio(corso, cercato);
      if (p >= 0) gruppi[p].push(corso);
    });
    return gruppi[0].concat(gruppi[1], gruppi[2], gruppi[3]);
  }

  var combo = null;   // riferimenti al campo facoltà, quando è a schermo

  function creaFacolta() {
    var sezione = document.createElement("section");
    sezione.className = "course-selection-faculty-view";
    var idTitolo = "course-selection-question-heading-macro";

    var contenitore = elemento("div", "course-selection-question-container course-selection-additional-ui course-selection-animate-in-surface");
    animaIngresso(contenitore, 0);
    if (CONFIG.show_counter && domanda("macro").counter) {
      contenitore.appendChild(elemento("p", "course-selection-question-counter", domanda("macro").counter));
    }
    var titolo = elemento("h2", "course-selection-question-heading", domanda("macro").label);
    titolo.id = idTitolo;
    contenitore.appendChild(titolo);
    sezione.appendChild(contenitore);

    // "Se non trovi la tua facoltà, scrivici"
    if (CONFIG.add_faculty_mailto && TESTI.mailto && TESTI.mailto.macro) {
      var mailto = elemento("a", "course-selection-faculty-mailto", TESTI.mailto.macro);
      mailto.href = "mailto:" + CONFIG.add_faculty_mailto;
      sezione.appendChild(mailto);
    }

    var box = document.createElement("section");
    box.id = "course-select-combobox";
    box.className = "course-selection-animate-in-surface";
    animaIngresso(box, RITARDO_PRIMA_SCELTA);

    var gruppo = elemento("div", "course-selection-combo");
    gruppo.id = "faculty-combo";

    var campo = elemento("input", "course-selection-combo-input");
    campo.id = "faculty-input";
    campo.type = "text";
    campo.autocomplete = "off";
    campo.placeholder = (TESTI.placeholder && TESTI.placeholder.macro) || "";
    campo.setAttribute("role", "combobox");
    campo.setAttribute("aria-autocomplete", "list");
    campo.setAttribute("aria-expanded", "false");
    campo.setAttribute("aria-controls", "faculty-listbox");
    campo.setAttribute("aria-haspopup", "listbox");
    campo.setAttribute("aria-labelledby", idTitolo);
    campo.setAttribute("aria-label", "Digita per cercare la tua facoltà o il tuo corso di studi. Usa le frecce per navigare i risultati e Invio per selezionare.");

    var apri = elemento("button", "course-selection-combo-toggle");
    apri.id = "faculty-toggle";
    apri.type = "button";
    apri.setAttribute("aria-controls", "faculty-listbox");
    apri.setAttribute("aria-expanded", "false");
    apri.setAttribute("aria-label", "Mostra suggerimenti");
    apri.dataset.expanded = "false";
    var freccia = elemento("span", "course-selection-combo-chevron");
    freccia.setAttribute("aria-hidden", "true");
    apri.appendChild(freccia);

    var lista = elemento("div", "course-selection-combo-list");
    lista.id = "faculty-listbox";
    lista.setAttribute("role", "listbox");
    lista.setAttribute("aria-label", "Risultati facolta");
    lista.hidden = true;

    gruppo.appendChild(campo);
    gruppo.appendChild(apri);
    gruppo.appendChild(lista);
    box.appendChild(gruppo);
    sezione.appendChild(box);

    collegaCombo(campo, apri, lista);
    return sezione;
  }

  function collegaCombo(campo, apri, lista) {
    var risultati = [];
    var attivo = -1;
    var chiusuraRitardata;

    combo = {
      campo: campo,
      pulisci: function () { campo.value = ""; risultati = []; attivo = -1; chiudi(); }
    };

    function apriLista() {
      lista.hidden = false;
      dom.modale.classList.add("course-selection-combobox-open");
      adattaAltezza();
      campo.setAttribute("aria-expanded", "true");
      apri.setAttribute("aria-expanded", "true");
      apri.setAttribute("aria-label", "Nascondi suggerimenti");
      apri.dataset.expanded = "true";
    }

    function chiudi() {
      lista.hidden = true;
      dom.modale.classList.remove("course-selection-combobox-open");
      campo.setAttribute("aria-expanded", "false");
      campo.removeAttribute("aria-activedescendant");
      apri.setAttribute("aria-expanded", "false");
      apri.setAttribute("aria-label", "Mostra suggerimenti");
      apri.dataset.expanded = "false";
      attivo = -1;
    }

    /** La tendina non deve uscire dalla modale (o dallo schermo, su mobile). */
    function adattaAltezza() {
      if (lista.hidden) return;
      var alto = lista.getBoundingClientRect().top;
      if (window.matchMedia("(max-width: 640px)").matches) {
        var fondoSchermo = window.visualViewport
          ? window.visualViewport.offsetTop + window.visualViewport.height
          : window.innerHeight;
        var spazio = Math.floor(fondoSchermo - alto - 16);
        lista.style.maxHeight = Math.min(300, Math.max(180, spazio)) + "px";
        return;
      }
      var spazioModale = Math.max(0, Math.floor(dom.modale.getBoundingClientRect().bottom - alto - 16));
      lista.style.maxHeight = Math.min(300, spazioModale) + "px";
    }

    function disegnaLista() {
      var frammento = document.createDocumentFragment();
      if (risultati.length === 0) {
        var vuoto = elemento("div", "course-selection-combo-empty", "Nessun risultato");
        vuoto.setAttribute("role", "status");
        frammento.appendChild(vuoto);
      }
      risultati.forEach(function (corso, i) {
        var voce = elemento("div", "course-selection-combo-option");
        voce.id = "faculty-opt-" + corso.id;
        voce.setAttribute("role", "option");
        voce.setAttribute("aria-selected", String(i === attivo));
        voce.setAttribute("aria-posinset", String(i + 1));
        voce.setAttribute("aria-setsize", String(risultati.length));
        voce.dataset.index = String(i);
        if (i === attivo) voce.classList.add("active");
        if (i === risultati.length - 1) voce.classList.add("is-last-result");
        voce.appendChild(elemento("span", null, corso.label));
        frammento.appendChild(voce);
      });
      lista.replaceChildren(frammento);
      if (attivo >= 0 && risultati[attivo]) {
        campo.setAttribute("aria-activedescendant", "faculty-opt-" + risultati[attivo].id);
      } else {
        campo.removeAttribute("aria-activedescendant");
      }
    }

    function filtra() {
      risultati = cercaCorsi(campo.value);
      attivo = risultati.length ? 0 : -1;
      apriLista();
      disegnaLista();
    }

    function muoviAttivo(passo) {
      if (!risultati.length) return;
      attivo = (attivo + passo + risultati.length) % risultati.length;
      disegnaLista();
      var voce = lista.querySelector('[data-index="' + attivo + '"]');
      if (voce) voce.scrollIntoView({ block: "nearest" });
    }

    function scegli(corso) {
      stato.scelte.facultyId = corso.id;
      stato.scelte.facultyLabel = corso.label;
      stato.scelte.macro = corso.macro;
      campo.value = corso.label;
      chiudi();
      campo.blur();
      calcolaPassoSuccessivo();
      disegna();
    }

    campo.addEventListener("input", filtra);
    campo.addEventListener("focus", filtra);
    campo.addEventListener("click", function () { if (lista.hidden) filtra(); });
    campo.addEventListener("blur", function () {
      chiusuraRitardata = window.setTimeout(chiudi, 100);
    });
    campo.addEventListener("keydown", function (evento) {
      if (evento.key === "ArrowDown") {
        if (lista.hidden) filtra();
        evento.preventDefault();
        muoviAttivo(1);
      } else if (evento.key === "ArrowUp") {
        if (lista.hidden) filtra();
        evento.preventDefault();
        muoviAttivo(-1);
      } else if (evento.key === "Enter") {
        if (!lista.hidden && attivo >= 0 && risultati[attivo]) {
          evento.preventDefault();
          scegli(risultati[attivo]);
        }
      } else if (evento.key === "Escape" || evento.key === "Tab") {
        chiudi();
      }
    });

    apri.addEventListener("mousedown", function (e) { e.preventDefault(); });
    apri.addEventListener("click", function () {
      window.clearTimeout(chiusuraRitardata);
      if (lista.hidden) { campo.focus(); filtra(); }
      else { chiudi(); campo.focus(); }
    });

    lista.addEventListener("mousedown", function (evento) {
      var voce = evento.target.closest("[data-index]");
      if (!voce) return;
      evento.preventDefault();
      window.clearTimeout(chiusuraRitardata);
      var corso = risultati[Number(voce.dataset.index)];
      if (corso) scegli(corso);
    });

    window.addEventListener("resize", adattaAltezza);
    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", adattaAltezza);
      window.visualViewport.addEventListener("scroll", adattaAltezza);
    }
  }

  /* ------------------------------------------------------- scheda del risultato */

  /** Apre il link nella stessa scheda o in una nuova, secondo le preferenze. */
  function impostaLink(elementoLink, url, nuovaScheda) {
    elementoLink.href = url;
    if (nuovaScheda) {
      elementoLink.target = "_blank";
      elementoLink.rel = "noopener noreferrer";
    } else {
      elementoLink.removeAttribute("target");
      elementoLink.removeAttribute("rel");
    }
  }

  function creaRisultato(corso) {
    var nome = corso.name;
    var blocco = elemento("div", "course-selection-result-block course-selection-animate-in-surface");
    blocco.dataset.resultCardDesktopLayout = LAYOUT_RISULTATO;
    blocco.dataset.resultBorder = String(!!CONFIG.show_result_border);
    blocco.dataset.resultBorderMobile = String(!!CONFIG.show_result_border_mobile);
    blocco.dataset.resultBorderWide = String(CONFIG.result_border_width > 2);
    blocco.dataset.resultInfoFade = String(!!CONFIG.fade_result_info);
    blocco.dataset.mobileResultState = "pending";
    blocco.style.setProperty("--course-selection-result-border-width", CONFIG.result_border_width + "px");
    blocco.style.setProperty("--course-selection-result-border-color", CONFIG.result_border_color);
    animaIngresso(blocco, 0);

    // colonna dei testi
    var colonna = elemento("div", "course-info-col course-selection-animate-in-result-copy");
    animaIngresso(colonna, RITARDO_TESTO_RISULTATO);

    var titolo = elemento("h2", "course-info-title", nome);
    titolo.tabIndex = -1;
    titolo.dataset.resultHeading = "true";
    colonna.appendChild(titolo);

    // per l'università il payoff è la facoltà scelta
    var payoff = corso.payoff || stato.scelte.facultyLabel || "";
    var rigaPayoff = elemento("h3", null, payoff);
    rigaPayoff.hidden = !payoff;
    colonna.appendChild(rigaPayoff);

    var rigaTempo = elemento("h4", null, corso.commitmentText || "");
    rigaTempo.hidden = !corso.commitmentText;
    colonna.appendChild(rigaTempo);

    var descrizione = elemento("p", null, corso.description || "");
    descrizione.hidden = !corso.description;
    colonna.appendChild(descrizione);

    var azioni = elemento("div", "course-info-actions");
    if (CONFIG.show_result_price && (corso.priceFull != null || corso.priceDiscounted != null)) {
      azioni.appendChild(creaPrezzo("course-selection-result-price", "div", corso));
    }

    var acquista = elemento("a", "course-selection-buy-now-button", "ACQUISTA");
    acquista.dataset.resultPrimaryAction = "true";
    acquista.setAttribute("aria-label", "Acquista " + nome);
    impostaLink(acquista, corso.buyFullLink, CONFIG.buy_full_to_new_tab);

    // il pulsante delle rate segue il link: se la scheda ne ha uno compare,
    // altrimenti no. Vale anche per gli upgrade, che per alcune offerte le hanno
    var rate = null;
    if (CONFIG.show_buy_installments && corso.buyInstallmentsLink) {
      rate = elemento("a", "course-selection-installments-button", "ACQUISTA A RATE");
      rate.setAttribute("aria-label", "Acquista " + nome + " a rate");
      impostaLink(rate, corso.buyInstallmentsLink, CONFIG.buy_installments_to_new_tab);
    }

    if (CONFIG.buy_full_before_installments) {
      azioni.appendChild(acquista);
      if (rate) azioni.appendChild(rate);
    } else {
      if (rate) azioni.appendChild(rate);
      azioni.appendChild(acquista);
    }
    colonna.appendChild(azioni);
    blocco.appendChild(colonna);

    // colonna dell'immagine (di solito cliccabile, porta all'acquisto)
    var immagine = elemento("a", "course-result-image -undash course-selection-animate-in-result-image is-loading");
    immagine.setAttribute("aria-hidden", "false");
    immagine.dataset.clickable = String(!!CONFIG.clickable_course_cover);
    if (CONFIG.clickable_course_cover) {
      impostaLink(immagine, corso.buyFullLink, CONFIG.course_cover_to_new_tab);
      immagine.setAttribute("aria-label", "Acquista " + nome);
    }
    animaIngresso(immagine, RITARDO_IMMAGINE_RISULTATO);

    var sfondo = elemento("div", "course-result-image-asset");
    sfondo.setAttribute("aria-hidden", "true");
    var velo = elemento("div", "course-result-image-cover");
    velo.setAttribute("aria-hidden", "true");
    var sfumatura = elemento("div", "course-result-image-fade");
    sfumatura.setAttribute("aria-hidden", "true");
    immagine.appendChild(sfondo);
    immagine.appendChild(velo);
    immagine.appendChild(sfumatura);
    blocco.appendChild(immagine);

    // l'immagine compare solo quando è pronta; su mobile la scheda si apre dopo
    function mostraScheda() {
      window.requestAnimationFrame(function () {
        blocco.dataset.mobileResultState = "ready";
      });
    }
    if (corso.picture) {
      caricaImmagine(corso.picture).then(function (ok) {
        if (ok) {
          sfondo.style.backgroundImage = 'url("' + corso.picture + '")';
          immagine.classList.remove("is-loading");
          immagine.classList.add("is-ready");
        } else {
          immagine.classList.remove("is-loading");
        }
        mostraScheda();
      });
    } else {
      immagine.classList.remove("is-loading");
      mostraScheda();
    }

    return blocco;
  }

  /* --------------------------------------------------------------- disegno

     Una sola funzione decide cosa si vede: la domanda in corso (o l'ultima
     data, quando c'è il risultato) e, se il percorso è finito, la scheda. */

  var pannelloCorrente = null;
  var corsoMostrato = null;
  var haInteragito = false;

  function disegna() {
    var mostraRisultato = stato.passo === "result";
    var passoDomanda = mostraRisultato ? passoPrecedente("result") : stato.passo;
    var chiave = [passoDomanda, stato.scelte.level || "", stato.scelte.tier || ""].join("|");

    if (!pannelloCorrente || pannelloCorrente !== chiave) {
      var pannello = passoDomanda === "faculty" ? creaFacolta() : creaDomanda(passoDomanda);
      if (passoDomanda !== "faculty") combo = null;
      dom.areaDomande.replaceChildren(pannello);
      pannelloCorrente = chiave;
    }

    // la domanda resta a schermo, ma con il risultato il titolo sparisce
    var contenitoreTitolo = dom.areaDomande.querySelector(".course-selection-question-container");
    if (contenitoreTitolo) {
      contenitoreTitolo.hidden = mostraRisultato;
      if (mostraRisultato) contenitoreTitolo.setAttribute("aria-hidden", "true");
      else contenitoreTitolo.removeAttribute("aria-hidden");
    }

    // evidenzia la risposta scelta
    var valoreScelto = stato.scelte[passoDomanda];
    Array.prototype.forEach.call(
      dom.areaDomande.querySelectorAll(".select-question-choice"),
      function (bottone) {
        var scelto = bottone.dataset.choiceValue === valoreScelto;
        bottone.dataset.selected = String(scelto);
        bottone.setAttribute("aria-pressed", String(scelto));
        bottone.classList.toggle("selected", scelto);
      }
    );

    // se si è tornati indietro, il campo facoltà torna vuoto
    if (passoDomanda === "faculty" && combo && !stato.scelte.macro && !mostraRisultato) {
      combo.pulisci();
    }

    var corso = mostraRisultato ? corsoScelto(stato.scelte) : null;
    if (corso) {
      var identificativo = corso.corso;
      if (corsoMostrato !== identificativo) {
        dom.areaRisultato.replaceChildren(creaRisultato(corso));
        corsoMostrato = identificativo;
      }
    } else if (corsoMostrato !== null) {
      dom.areaRisultato.replaceChildren();
      corsoMostrato = null;
    }

    dom.pannelli.classList.toggle("showing-result", mostraRisultato);
    dom.modale.classList.toggle("showing-result", mostraRisultato);

    aggiornaNav();
    portaIlFocus(passoDomanda, mostraRisultato);
  }

  /** Dopo un clic sposta il cursore dove serve, per chi naviga da tastiera. */
  function portaIlFocus(passoDomanda, mostraRisultato) {
    if (!haInteragito) return;
    var bersaglio = null;
    if (mostraRisultato) {
      bersaglio = dom.areaRisultato.querySelector('[data-result-primary-action="true"]') ||
        dom.areaRisultato.querySelector('[data-result-heading="true"]');
    } else if (passoDomanda === "faculty") {
      bersaglio = dom.areaDomande.querySelector("#faculty-input");
    } else {
      bersaglio = dom.areaDomande.querySelector('[data-choice-step="' + passoDomanda + '"][data-selected="true"]') ||
        dom.areaDomande.querySelector('[data-choice-step="' + passoDomanda + '"]');
    }
    if (!bersaglio) return;
    if (bersaglio.tagName === "INPUT") bersaglio.focus();
    else bersaglio.focus({ preventScroll: true });
  }

  /* ------------------------------------------------------------ interazioni */

  dom.indietro.addEventListener("click", function () {
    var precedente = passoPrecedente(stato.passo);
    if (precedente === stato.passo) return;
    haInteragito = true;
    tornaA(precedente);
    disegna();
  });

  dom.barre.forEach(function (barra, i) {
    var passo = ["level", "tier", "commitment", "faculty"][i];
    barra.contenitore.addEventListener("click", function () {
      haInteragito = true;
      tornaA(passo);
      disegna();
    });
  });

  dom.breadcrumb.addEventListener("click", function (evento) {
    var voce = evento.target.closest("[data-breadcrumb-step]");
    if (!voce) return;
    haInteragito = true;
    tornaA(voce.dataset.breadcrumbStep);
    disegna();
  });

  dom.areaDomande.addEventListener("click", function (evento) {
    if (evento.target.closest(".select-question-choice")) haInteragito = true;
  }, true);

  /* ------------------------------------------------------------------ avvio */

  function immaginiDelPrimoPasso() {
    var valori = opzioniDelPasso(PASSO_INIZIALE);
    return valori.map(function (v) { return opzione(v).picture; }).filter(Boolean);
  }

  function immaginiDaPrecaricare() {
    var urls = [];
    ["base", "pro", "master", "full", "part"].forEach(function (v) {
      if (TESTI.selectOptions[v] && TESTI.selectOptions[v].picture) urls.push(TESTI.selectOptions[v].picture);
    });
    CATALOGO.forEach(function (riga) { if (riga.picture) urls.push(riga.picture); });
    return urls.filter(function (url, i, tutte) { return tutte.indexOf(url) === i; });
  }

  function avvia() {
    dom.modale.dataset.uiReady = "false";
    dom.modale.dataset.enterAnimationPreset = PRESET_ANIMAZIONE;

    calcolaPassoSuccessivo();
    if (!stato.scelte.level && LIVELLO_FISSO) stato.scelte.level = LIVELLO_FISSO;
    stato.passo = stato.passo === "result" ? stato.passo : PASSO_INIZIALE;

    attendiImmagini(immaginiDelPrimoPasso(), ATTESA_MASSIMA_IMMAGINI).then(function () {
      disegna();
      // le altre immagini si caricano in sottofondo, per i passi successivi
      immaginiDaPrecaricare().forEach(caricaImmagine);
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          dom.modale.dataset.uiReady = "true";
        });
      });
    });
  }

  avvia();
})();
